
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/treasury",
      function () {
        return require("private-next-pages/treasury/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/treasury"])
      });
    }
  